<template>
  <v-app>
    <v-main>
      <router-view />
      <notifications
        name="error-notification"
        position="top left"
        width="100%"
      />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
</style>
